/**
 * Returns an array of an object's own enumerable property names.
 * Alias for Object.keys providing a more functional API.
 *
 * @param obj - Object to extract keys from
 * @returns Array of property names
 *
 * @example
 * ```ts
 * import { Keys } from "@pdfking/tfunc"
 *
 * const obj = { name: "John", age: 30 }
 * const keys = Keys(obj) // ["name", "age"]
 *
 * keys.forEach(key => {
 *   console.log(key)
 * })
 * ```
 */
export const Keys = Object.keys
